import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=f33b4608&scoped=true"
import script from "./NavigationItem.vue?vue&type=script&lang=js"
export * from "./NavigationItem.vue?vue&type=script&lang=js"
import style0 from "./NavigationItem.vue?vue&type=style&index=0&id=f33b4608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33b4608",
  null
  
)

export default component.exports